<template>
  <el-row class="home-container">
    <el-col class="search-container">
      <main-search v-if="!isMobile" />
      <el-row
        v-if="!isMobile"
        type="flex"
        justify="center"
      >
        <search-categories />
      </el-row>
    </el-col>
    <el-col class="ads-flex">
      <div class="control-container container">
        <h1
          v-if="!isMobile"
          class="ads1-title"
          :class="reverseText"
        >
          <!--{{ $t('home.promoted.title') }}-->
          <b v-if="subcategory.key && category.key">{{ $t('subcategory.' + category.key + '.' + subcategory.key) }}</b>
          <b v-if="category.key && !subcategory.key ">{{ $t('category.' + category.key) }}</b>
        </h1>
        <!--<scroll-wrapper>-->
        <app-header v-if="isMobile" />
        <div class="wrap-container">
          <div
            class="offset-container"
            :style="isMobile ? 'margin-top: 0;' : ''"
          >
            <template v-if="isMobile">
              <entity-list
                ref="entityList"
                res="ads"
                :filter="getRequestFilters || []"
                :sort="[['publish_date', 'desc']]"
                :res-options="resourceOptions"
                :post-on-index="false"
                :full-loader="false"
              >
                <template slot="before-list">
                  <div
                    v-observe-visibility="headerVisible"
                    style="display:block; width: 100%; height: 1px;"
                  />
                  <el-row class="custom-margin-bottom">
                    <search-filters />
                    <location-select v-if="isMobile" />
                  </el-row>
                  <div
                    :class="{ hVisibleSpacer: isHeaderVisible }"
                    class="home-filters"
                  />
                </template>
                <template
                  slot="list"
                  slot-scope="slotProps"
                >
                  <div class="list-wrapper">
                    <div
                      transition-duration="0.3s"
                      item-selector=".col-item"
                    >
                      <el-col
                        v-for="(adItem, index) in (slotProps.list.length ? slotProps.list : Array(10).fill({ price: 0 }))"
                        :key="adItem.id"
                        class="col-item"
                        :span="12"
                      >
                        <ads-item
                          :item="adItem"
                          :index="index"
                        />
                      </el-col>
                    </div>
                  </div>
                </template>
              </entity-list>
            </template>
            <template v-else>
              <entity-list
                ref="entityList"
                res="ads"
                :filter="getRequestFilters || []"
                :sort="[['publish_date', 'desc']]"
                :res-options="resourceOptions"
                :post-on-index="false"
              >
                <template
                  slot="item"
                  slot-scope="slotProps"
                >
                  <el-col
                    :sm="12"
                    :md="8"
                  >
                    <ads-item
                      :item="slotProps.item"
                      :state="true"
                    />
                  </el-col>
                </template>
              </entity-list>
            </template>
            <!--<div v-if="!isMobile" class="banner">-->
            <!--<img src="../assets/mcd.png" class="image">-->
            <!--</div>-->
          </div>
        </div>
        <!--</scroll-wrapper>-->
      </div>
    </el-col>
    <footer-menu v-if="isMobile" />
  </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LocationSelect from '../components/Mobile/LocationSelect';
import FooterMenu from '../components/Mobile/FooterMenu';
import MainSearch from '../components/MainSearch';
import AdsItem from '../components/Ads/AdsItem';
import SearchCategories from '../components/SearchCategories';
import SearchFilters from '../components/Mobile/SearchFilters';
import EntityList from '../components/Core/EntityList';
import AppHeader from '../components/AppHeader';

export default {
  components: {
    SearchFilters,
    AdsItem,
    FooterMenu,
    LocationSelect,
    SearchCategories,
    MainSearch,
    EntityList,
    AppHeader,
  },

  data() {
    return {
      isHeaderVisible: true,
      resourceOptions: {
        file: true,
        currency: true,
        favoring_logged_in_user: true,
      },
    };
  },

  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      // sort: state => state.temp.sort,
      category: state => state.filters.category || {},
      subcategory: state => state.filters.subcategory || {},
    }),
    ...mapGetters([
      'getRequestCategoryFilters',
      'getRequestSearchFilters',
      'getRequestSorts',
    ]),
    getRequestFilters() {
      return [{
        property: 'active',
        operator: '=',
        value: true,
      },
        ...this.getRequestCategoryFilters,
        ...this.getRequestSearchFilters,
      ];
    },
    reverseText() {
      return false;
    },
  },

  watch: {
    // On filter change do a refresh
    getRequestFilters() {
      setTimeout(() => this.$refs.entityList.doRefresh());
    },
    getRequestSorts() {
      setTimeout(() => this.$refs.entityList.doRefresh());
    },
  },

  methods: {
    headerVisible(visible) {
      this.isHeaderVisible = visible;
    },
  },
};
</script>
<style>
    .test-header {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
    }

    .home-container {
        /*height: 100%;*/
        /*overflow: auto;*/
        z-index: 1;
        display: flex;
        flex-direction: column;
    }

    .test-footer {
        position: fixed;
        width: 100%;
        bottom: 0;
        left: 0;
    }

    .test-content {
        margin-top: 20px;
        margin-bottom: 19px;
        flex: 1;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue